import { render } from "./PersoonBewerken.vue?vue&type=template&id=5c5bfd28&scoped=true"
import script from "./PersoonBewerken.vue?vue&type=script&lang=js"
export * from "./PersoonBewerken.vue?vue&type=script&lang=js"

import "./PersoonBewerken.vue?vue&type=style&index=0&id=5c5bfd28&scoped=true&lang=css"

import exportComponent from "/Users/vincent/Documents/GIT_CLONES/skipiste/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c5bfd28"]])

export default __exports__